import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'PUBLIC_',
  client: {
    PUBLIC_API_URL: z.string().url(),
    PUBLIC_AUTH0_AUDIENCE: z.string().min(1),
    PUBLIC_AUTH0_CLIENT_ID: z.string().min(1),
    PUBLIC_AUTH0_DOMAIN: z.string().min(1),
    PUBLIC_LAUNCH_DARKLY_CLIENT_ID: z.string().min(1),
    PUBLIC_API_ENDPOINT: z.string().url(),
  },
  runtimeEnvStrict: {
    PUBLIC_API_URL: import.meta.env.VITE_API_URL,
    PUBLIC_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
    PUBLIC_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    PUBLIC_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
    PUBLIC_LAUNCH_DARKLY_CLIENT_ID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    PUBLIC_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  },
});
